import(/* webpackMode: "eager", webpackExports: ["ShareButtons"] */ "/tmp/8de371382fe6e8e/components/blog/ShareButtons.tsx");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Container.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Section.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Button.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/blog/BlogCard.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/ui/Heading.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/components/blog/RelatedPosts.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/app/[locale]/blog/[slug]/page.module.css");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/tmp/8de371382fe6e8e/node_modules/next/dist/client/link.js");
